var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imager"},[_c('div',{staticClass:"image",style:({ 
      backgroundImage: ("url(" + _vm.mySrc),
      width: _vm._width,
      height: _vm._height
    }),on:{"click":function($event){return _vm.imagePreview()}}}),_vm._v(" "),_c('el-dialog',{attrs:{"title":"预览","width":"40%","top":"8vh","visible":_vm.isPreviewImage,"append-to-body":true},on:{"update:visible":function($event){_vm.isPreviewImage=$event}}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('img',{staticStyle:{"width":"100%","height":"auto"},attrs:{"src":_vm.mySrc},on:{"load":function($event){_vm.loading = false}}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2adcdc3b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Imager.vue
// module id = null
// module chunks = 